import React, { useState, useReducer, useMemo, useEffect } from "react";
import PropTypes from "prop-types";

import Sidebar from "./Sidebar";
import Toolbar from "./Toolbar";
import SlidingPopup from "App/common/hoc/SlidingPopup";
import Transition from "App/common/ui/Transition";
import Popup from "App/common/hoc/Popup";
import { layoutReducer } from "App/common/reducer";
import { forbidExtraProps } from "utils";
import { ROUTECLASS_LIST, TRANSITION_CLASSESS } from "App/componentsConfig";

export const LayoutContext = React.createContext({
  lState: {},
  lMethods: {}
});

function Layout(props) {
  const [scrolledToTop, setScrolledToTop] = useState(true);
  const initialState = useMemo(
    () => ({
      sidebarCollapse: false,
      slidingPopup: {
        show: false,
        alertName: "",
        tab: "",
        params: null
      },
      backupStats: { show: false },
      popup: { show: false, alertName: "", params: null },
      notification: false
    }),
    []
  );
  const [lState, dispatch] = useReducer(layoutReducer, initialState);
  const lMethods = useMemo(
    () => ({
      openPopup: (alertName, params) =>
        dispatch({ type: "OPEN_POPUP", alertName: alertName, params: params }),
      updatePopupParams: params =>
        dispatch({ type: "UPDATE_POPUP_PARAMS", params: params }),
      closePopup: () => dispatch({ type: "CLOSE_POPUP" }),
      openSlidingPopup: (alertName, tab, params) =>
        dispatch({
          type: "OPEN_SLIDING_POPUP",
          alertName: alertName,
          tab: tab,
          params: params
        }),
      switchSlidingPopup: (alertName, tab, params) =>
        dispatch({
          type: "SWITCH_SLIDING_POPUP",
          alertName: alertName,
          tab: tab,
          params: params
        }),
      closeSlidingPopup: () => dispatch({ type: "CLOSE_SLIDING_POPUP" }),
      toggleSidebar: () => dispatch({ type: "TOGGLE_SIDE_BAR" }),
      toggleBackupStats: () => dispatch({ type: "TOGGLE_BACKUP_STATS" }),
      closeBackupStats: () => dispatch({ type: "CLOSE_BACKUP_STATS" }),
      disablePopupConfirm: disable =>
        dispatch({ type: "DISABLE_POPUP_CONFIRM", disable: disable }),
      disableLeftFooter: (remove, disable) =>
        dispatch({
          type: "DISABLE_LEFT_FOOTER",
          remove: remove,
          disable: disable
        }),
      toggleNotificationClass: toggleShow =>
        dispatch({ type: "TOGGLE_NOTIFICATION_CLASS", toggleShow })
      // changeSlidingPopupAlert: (alertName, tab) =>
      //   dispatch({
      //     type: "CHANGE_SLIDING_POPUP_ALERT",
      //     alertName: alertName,
      //     tab: tab
      //   })
    }),
    []
  );

  useEffect(() => {
    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  function onScroll() {
    if (window.pageYOffset > 10) {
      setScrolledToTop(false);
    } else {
      setScrolledToTop(true);
    }
  }

  return (
    <LayoutContext.Provider value={{ lState, lMethods }}>
      <div
        className={[
          "main_wrapper",
          props.auth.isFirst && props.route.pathname.includes("dashboard")
            ? ROUTECLASS_LIST["welcome"]
            : ROUTECLASS_LIST[props.route.pathname.split("/")[2]],
          lState.slidingPopup.show ? "slider_active" : "",
          lState.backupStats.show ? "no-scroll" : "",
          ((props.expiryDays < 1 &&
            props.planType !== "Paid" &&
            props.ecommerceFlag !== "S" &&
            props.ecommerceFlag !== "Y" &&
            props.ecommerceFlag !== "O") ||
            props.auth.pnsDown ||
            (props.planType === "Trial" && props.ccfailureAccount)) &&
          props.route.pathname.includes("dashboard")
            ? "static_notification"
            : "",
          scrolledToTop ? "" : "scroll_shadow",
          props.origin === "360"
            ? "idrive360_user"
            : props.origin === "ibackup"
            ? "ibackup_user"
            : ""
        ].join(" ")}
      >
        <Toolbar
          route={props.route}
          noOfClients={props.noOfClients}
          origin={props.origin}
          ecommerceFlag={props.ecommerceFlag}
        />

        <div
          className={[
            "main_body is_relative",
            lState.sidebarCollapse ? "is-collapsed" : ""
          ].join(" ")}
        >
          <Sidebar
            ecommerceFlag={props.ecommerceFlag}
            origin={props.origin}
            route={props.route}
          />

          <div
            className={[
              "main_container dashboard_table_grid",
              props.route.pathname.split("/")[2] === "users"
                ? "mir_user_page"
                : ""
            ].join(" ")}
          >
            {props.children}
          </div>
        </div>

        <Transition
          {...{
            show: lState.slidingPopup.show,
            ...TRANSITION_CLASSESS.slidingPopup[
              lState.slidingPopup.alertName === "addPC"
                ? "mainAddComputer"
                : "main"
            ]
          }}
        >
          <SlidingPopup />
        </Transition>

        {lState.popup.show && <Popup />}
      </div>
    </LayoutContext.Provider>
  );
}

Layout.propTypes = forbidExtraProps(
  {
    auth: PropTypes.shape({
      entityStatus: PropTypes.number
    }),
    children: PropTypes.element,
    noOfClients: PropTypes.number
  },
  [
    "route",
    "expiryDays",
    "planType",
    "ccfailureAccount",
    "ecommerceFlag",
    "origin",
    "dashboardNotification"
  ]
);

export default Layout;
